import React from 'react'

import { SensitiveData } from '@ui/Privacy/SensitiveData'
import { IconButton } from '@ui/components/Button'
import { CalendarIcon } from '@ui/icons/Calendar.icon'
import { EditIcon } from '@ui/icons/Edit.icon'

import { renderCellValue } from '../utils/formatters'

import styles from './EditableCellContent.module.scss'

type Props<T = unknown> = {
  value: T | null | undefined
  onEdit?: () => void
  editAriaLabel?: string
  renderValue?: (value: T | null | undefined) => React.ReactNode
  iconSize?: number
  iconType?: 'edit' | 'calendar'
  iconRender?: (size: number) => React.ReactNode
  className?: string
  showIconWhenEmpty?: boolean
  sensitive?: boolean
}

export const EditableCellContent = <T,>({
  value,
  onEdit,
  editAriaLabel = 'Edit',
  renderValue,

  iconType = 'edit',
  sensitive = false,
  className,
}: Props<T>) => {
  const icon = iconType === 'calendar' ? CalendarIcon : EditIcon

  const data = <>{renderValue ? renderValue(value) : renderCellValue(value)}</>
  const hasData = value != null && value != undefined
  const isSensitive = sensitive && hasData

  return (
    <div className={`${styles.cellWithEndIcon} ${className ?? ''}`}>
      <span className={styles.cellValue}>
        {isSensitive ? <SensitiveData>{data}</SensitiveData> : hasData ? data : '-'}
      </span>

      <IconButton.Ghost
        aria-label={editAriaLabel}
        onClick={(e) => {
          e.stopPropagation()
          onEdit?.()
        }}
        icon={{ icon, color: 'text-med-em' }}
      />
    </div>
  )
}

export default EditableCellContent
